var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
// subcomponents
import CardMedia from "./CardMedia";
import CardHeader from "./CardHeader";
import CardFooter from "./CardFooter";
import CardContent from "./CardContent";
import CardTable from "./CardTable";
import CardContainer from "./CardContainer";
// styles
import "./card.scss";
// use the optional prop interface to define the default props
const defaultProps = {
    "data-testid": "tecma-card",
    className: undefined,
    style: undefined,
    orientation: "vertical",
    selected: false,
};
const Card = (_a) => {
    var { className, children, fluid, orientation, selected, setSelected, borderLess } = _a, rest = __rest(_a, ["className", "children", "fluid", "orientation", "selected", "setSelected", "borderLess"]);
    const classList = classNames("tecma-card", { fluid }, { [`${orientation}`]: orientation }, { selected }, { borderLess }, className);
    return (_jsx("div", Object.assign({ "aria-hidden": "true", className: classList, onClick: setSelected }, rest, { children: children })));
};
Card.defaultProps = defaultProps;
const CardSpace = Object.assign(Card, {
    Header: CardHeader,
    Footer: CardFooter,
    Content: CardContent,
    Media: CardMedia,
    Table: CardTable,
    Container: CardContainer,
});
export { CardSpace as Card };
